import ReactDOM from 'react-dom';
import { isString, isPlainObject } from 'lodash';

export function generateImage(image, type) {
  if (!image) {
    return null;
  }

  if (isString(image)) {
    return { image, type: 'url' };
  }

  if (isPlainObject(image)) {
    if (type) {
      const data = image[type] ?? image.childImageSharp?.[type];

      if (data) {
        return { image: data, type };
      }
    } else {
      const fluid = image.fluid ?? image.childImageSharp?.fluid;
      const fixed = image.fixed ?? image.childImageSharp?.fixed;

      if (fluid) {
        return { image: fluid, type: 'fluid' };
      } else if (fixed) {
        return { image: fixed, type: 'fixed' };
      }
    }
  }

  return image ?? null;
}

export function generateBackgroundImage(image, type) {
  const bg = generateImage(image, type);

  if (bg?.type === 'url') {
    bg.image = `url('${bg}')`;
  }

  return bg ?? null;
}

export function isBrowser() {
  return typeof window !== 'undefined';
}

export function createPortal(content) {
  return isBrowser()
    ? ReactDOM.createPortal(content, document.body)
    : content;
}

export function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}
